export default __webpack_public_path__ + "static/media/skillUp.0356e75c.png";